import React, { Component } from "react";
import ClickList from "../components/ClickList";
import axios from "axios";
import { API_HOST } from "../components/utils/api-config";
class ClicksContainer extends Component {
  constructor() {
    super();
    this.state = {
      clicks: null,
      linkMerchants: null,
      customerMerchants: null,
    };
  }

  componentDidMount() {
    axios.get(`${API_HOST}/clicks`).then((response) =>
      this.setState({
        clicks: response.data.clicks,
        linkMerchants: response.data.linkMerchants,
        customerMerchants: response.data.customerMerchants,
      })
    );
  }

  render() {
    return !this.state.clicks ? (
      <h1>Loading</h1>
    ) : (
      <div className="container-fluid pt-5">
        <h1>Click Tracking - {this.state.clicks.length} clicks</h1>
        <ClickList
          clicks={this.state.clicks}
          linkMerchants={this.state.linkMerchants}
          customerMerchants={this.state.customerMerchants}
        />
      </div>
    );
  }
}

export default ClicksContainer;
